import React from "react";

export const Loading: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="flex flex-col items-center gap-3">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted-foreground/20 border-t-foreground" />
      <p className="text-sm text-muted-foreground">Loading...</p>
    </div>
  </div>
);
